export default __webpack_public_path__ + "static/media/Cosmo.492f42aa.png";